import { Tkv2OrderAttachment } from '@aloft/toolkit-shared';
import { UseQueryResult } from '@tanstack/react-query';

import { useParams } from 'react-router';

import { listingsToVacantLandSalesProps } from '../components/VacantLandSales/listingsToVacantLandSalesProps.ts';
import { VacantLandSalesProperty } from '../components/VacantLandSales/types.ts';
import { selectCoordinatesById } from '../redux/features/selectors/propertyDataSelectors/propertyIdentificationSelectors.ts';
import { useAppSelector } from '../redux/hooks.ts';
import { useGetVacantLandSales } from './api/toolkitComponents.ts';

export const useVacantLandSales = (): VacantLandSalesProperty[] | undefined => {
  const orderID = useParams().orderId!;
  const subjectCoordinates = useAppSelector((state) => selectCoordinatesById(state, 'subject'));

  const { data, error, isLoading }: UseQueryResult<Tkv2OrderAttachment<'vacantLandSales'>> =
    useGetVacantLandSales({ pathParams: { orderID } });

  if (isLoading || error || !data || data.body.body.status !== 'found') return undefined;

  const { results } = data.body.body.output;
  return listingsToVacantLandSalesProps(results, subjectCoordinates);
};
